import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function EmailPacketDialog({ customerId, company, onSent, variant = "packet" }) {
  const binder = variant === "binder";
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ to: "", agent_name: "", note: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(binder ? `/company/${customerId}/hazmat/binder/email` : `/customers/${customerId}/packet/email`, { ...form, origin_url: window.location.origin });
      toast.success(`${binder ? "Binder" : "Packet"} link emailed to ${form.to} · valid 7 days`); setOpen(false); setForm({ to: "", agent_name: "", note: "" }); onSent?.();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant="outline" className={binder ? "border-orange-300 text-orange-800 hover:bg-orange-50" : ""} data-testid={binder ? "email-binder-button" : "email-packet-button"}><Send className="h-4 w-4 mr-2" />{binder ? "Email binder to inspector" : "Email packet to agent"}</Button></DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>{binder ? "Email hazmat audit binder" : "Email insurance packet"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <p className="text-sm text-slate-600">{binder ? "The inspector or agent" : "Your agent"} receives a branded email with a secure download link to the latest {binder ? "audit binder" : "packet"} for <b>{company}</b>. The link expires in 7 days.</p>
          <div><Label>{binder ? "Recipient" : "Agent"} email</Label><Input required type="email" value={form.to} onChange={(e) => setForm({ ...form, to: e.target.value })} data-testid="email-packet-to-input" /></div>
          <div><Label>{binder ? "Recipient" : "Agent"} name (optional)</Label><Input value={form.agent_name} onChange={(e) => setForm({ ...form, agent_name: e.target.value })} data-testid="email-packet-name-input" /></div>
          <div><Label>Note (optional)</Label><Textarea rows={4} maxLength={1500} placeholder="e.g. Here's our updated driver list for the renewal quote…" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} data-testid="email-packet-note-input" /></div>
          <DialogFooter><Button type="submit" disabled={busy} className="bg-blue-700 hover:bg-blue-800" data-testid="email-packet-send-button">{busy ? "Sending…" : "Send"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
